// Mirror of CommonPdfIntroductionSection.jsx: name block (optionally next to the
// Alcyone spinner) + optional justified introduction paragraph.

import { AlignmentType, ImageRun, TableRow, VerticalAlign } from "docx";
import { getInitials } from "../../../../utils/getInitials";
import { formatPrenom } from "../../../../utils/formatPrenom";
import { scaleToHeight } from "../../shared/wordImage";
import { cell, frac, layoutTable, para, run } from "../../shared/wordHelpers";
import { FONT_ARIAL, HEADER_GREY } from "../../shared/wordTheme";

export function buildCommonIntroduction( { data, props, spinnerImage } ) {
    const { user, introduction } = data;
    const { isAnonymous, isAlcyone, jobTitle } = props;

    const name = isAnonymous
        ? `${ getInitials( user?.firstName ) } ${ getInitials( user?.lastName, true ) }`
        : `${ formatPrenom( user?.firstName ) } ${ user?.lastName?.toUpperCase() ?? "" }`;

    const namePara = para( run( name, { pt: 16, bold: true, font: FONT_ARIAL } ), { spacing: { after: 0 } } );
    const jobPara = jobTitle
        ? para( run( jobTitle, { pt: 12, bold: true, color: HEADER_GREY, font: FONT_ARIAL } ), { spacing: { after: 0 } } )
        : null;
    const nameBlock = [ namePara, ...( jobPara ? [ jobPara ] : [] ) ];

    const elements = [];

    if ( isAlcyone && spinnerImage ) {
        const size = scaleToHeight( spinnerImage, 50 );
        const left = frac( 0.12 );
        const right = frac( 0.88 );
        elements.push( layoutTable(
            [
                new TableRow( {
                    children: [
                        cell(
                            para( new ImageRun( { data: spinnerImage.data, transformation: size } ), { spacing: { after: 0 } } ),
                            { widthTwips: left, valign: VerticalAlign.CENTER }
                        ),
                        cell( nameBlock, { widthTwips: right, valign: VerticalAlign.CENTER } ),
                    ],
                } ),
            ],
            { columnWidths: [ left, right ] }
        ) );
    } else {
        elements.push( ...nameBlock );
    }

    const hasIntroduction = typeof introduction === "string"
        ? introduction.trim() !== ""
        : Boolean( introduction );
    if ( hasIntroduction ) {
        elements.push( para(
            run( introduction, { pt: 8, font: FONT_ARIAL } ),
            { alignment: AlignmentType.JUSTIFIED, spacing: { before: 80, after: 80 } }
        ) );
    }

    return elements;
}
